import React, { useState } from 'react';
import { OpportunityLanding } from './OpportunityLanding';
import { QuickProfile } from './QuickProfile';
import { Screener } from './Screener';
import { ScreenerBridge } from './ScreenerBridge';
import { OpportunityReflect } from './OpportunityReflect';
import { SAMPLE_OPPORTUNITY, SCREENER_QUESTIONS, SEED_QUESTIONS } from './opportunityData';

export const OpportunityFlow = ({ onBack, study }) => {
  const [step, setStep] = useState(0);
  const opp = study || SAMPLE_OPPORTUNITY;
  const questions = SCREENER_QUESTIONS[opp.condition] || [];
  const reflectQ = (SEED_QUESTIONS[opp.condition] || [])[0];

  const [formData, setFormData] = useState({
    firstName: '', lastName: '', email: '', dateOfBirth: '', phone: ''
  });
  const [screenerAnswers, setScreenerAnswers] = useState({});

  const updateForm = (changes) => setFormData(prev => ({ ...prev, ...changes }));
  const updateScreener = (id, value) => setScreenerAnswers(prev => ({ ...prev, [id]: value }));

  // Check if any disqualifying answer was given
  const isQualified = () => {
    return !questions.some(q =>
      q.disqualifyOn && screenerAnswers[q.id] === q.disqualifyOn
    );
  };

  const steps = [
    <OpportunityLanding key={0} opportunity={opp} onNext={() => setStep(1)} />,

    <QuickProfile key={1} formData={formData} onUpdate={updateForm}
      opportunityCondition={opp.condition} onNext={() => setStep(2)} />,

    <Screener key={2} questions={questions} answers={screenerAnswers}
      onUpdateAnswer={updateScreener} opportunityPay={opp.pay}
      onNext={() => setStep(3)} onBack={() => setStep(1)} />,

    <ScreenerBridge key={3}
      firstName={formData.firstName || 'there'}
      condition={opp.condition}
      qualified={isQualified()}
      onStartReflect={() => setStep(4)} />,

    reflectQ && (
      <OpportunityReflect key={4}
        question={reflectQ} condition={opp.condition}
        onDone={onBack} />
    )
  ];

  return steps[step] || steps[0];
};
